// One hue per role, indexed by order in EXPERIENCE. Light/dark pairs picked for contrast on both themes.
export const ROLE_COLORS = [
  { name: 'teal',   light: '#0f766e', dark: '#2dd4bf' },
  { name: 'amber',  light: '#b45309', dark: '#fbbf24' },
  { name: 'violet', light: '#6d28d9', dark: '#a78bfa' },
  { name: 'rose',   light: '#be123c', dark: '#fb7185' },
];
export const roleVar = (i) => `var(--role-${i % ROLE_COLORS.length})`;
